import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { PERMISSIONS } from '@app/core/constants/permissions.constants'
import { PermissionService } from '@core/services/permission-service/permission-service'

/**
 * Allows Field Visit when IAM grants `view_field_visit`.
 *
 * Until IAM publishes that permission, `getPermissionByName` returns undefined and only
 * full-access users get through — the same implicit-full-access fallback the academic
 * calendar guard relies on. Field Visit is deliberately NOT gated on
 * `view_academic_calendar`: the two features share no audience by design.
 */
export const fieldVisitAccessGuard: CanActivateFn = async () => {
    const permissionService = inject(PermissionService)
    const router = inject(Router)

    await permissionService.getPermissionsBitwise()

    if (permissionService.canAccessPermissionOrImplicitFullAccess(PERMISSIONS.VIEW_FIELD_VISIT)) {
        return true
    }

    await router.navigate(['/'])
    return false
}
